import React, {useEffect} from 'react'
import Select from 'react-select'
import { useTranslation } from 'react-i18next'

const LodginList = ({data, lodgin, onLodginSelected, stepStatus}) => {
  const { t, i18n } = useTranslation()

  useEffect(() => {
    if (stepStatus !== 'active') return

    onLodginSelected(data[0])
  }, [stepStatus])

  const formatOptionLabel = (lodgin, {context}) => {
    if (context === 'menu') {
      return (
        <div className="d-flex justify-content-between">
          <div>
            {lodgin.name}
            {lodgin.distance &&
              <small className="ms-2">
                {lodgin.distance}
                <a className="ms-2" href={lodgin.gmap} target="_blank" rel="noreferrer noopener">
                  ({i18n.t('lodgin_list.map_link')})
                </a>
              </small>
            }
          </div>
        </div>
      )
    } else {
      return (
        <div className="d-flex justify-content-between">
          <div>{lodgin.name}</div>
          {lodgin.distance &&
            <>
              <div className="px-2"><small>{lodgin.distance}</small></div>
              <div>
                <small>
                  <a href={lodgin.gmap} target="_blank" rel="noreferrer noopener">
                    ({i18n.t('lodgin_list.map_link')})
                  </a>
                </small>
              </div>
            </>
          }
        </div>
      )
    }
  }

  return (
    <Select
      onChange={(lodgin) => onLodginSelected(lodgin)}
      formatOptionLabel={formatOptionLabel}
      options={data}
      defaultValue={data[0]}
      value={lodgin}
    />
  )
}

export default LodginList
